<template>
  <!--有奖问答-->
  <div class="questionbg">
    <div class="info-text">
      <img
        class="info-img"
        src="../../assets/images/activity/workshop/question.png"
      />
    </div>
    <div class="info-content">
      <div class="input-row">
        <div class="info-name icon-user">
          <div class="info-icon"></div>
          <span>你喜欢易加网的哪项增值服务（多选）</span>
          <van-checkbox-group v-model="likeService">
            <van-checkbox name="01" shape="square"
              >门店进行销存管理</van-checkbox
            >
            <van-checkbox name="02" shape="square">车主促销管理</van-checkbox>
            <van-checkbox name="03" shape="square"
              >和其他品牌共同积分</van-checkbox
            >
            <van-checkbox name="04" shape="square">增加礼品种类</van-checkbox>
            <van-checkbox name="05" shape="square">其他</van-checkbox>
          </van-checkbox-group>
          <van-field
            v-model="likeServiceOther"
            maxlength="50"
            v-if="likeService.indexOf('05') > -1"
            center
          />
          <van-field
            v-model="likeServiceOther"
            v-else
            maxlength="50"
            disabled
            center
          />
        </div>
      </div>
      <div class="input-row">
        <div class="icon-user">
          <div class="info-icon"></div>
          <span>你喜欢易加网公众号哪些内容（多选）</span>
          <van-checkbox-group v-model="likeContent">
            <van-checkbox name="01" shape="square">修车类漫画</van-checkbox>
            <van-checkbox name="02" shape="square"
              >产品和礼品相关短视频</van-checkbox
            >
            <van-checkbox name="03" shape="square">礼品推荐</van-checkbox>
            <van-checkbox name="04" shape="square">促销活动介绍</van-checkbox>
            <van-checkbox name="05" shape="square"
              >行业相关动态分享</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>
    </div>
    <div class="submit-btn">
      <van-button
        :loading="loading"
        type="info"
        size="normal"
        round
        @click="handleSubmit"
        ><img
          class="imgbtn"
          src="../../assets/images/activity/workshop/submit.png"
      /></van-button>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
export default {
  name: 'ActivityWorkshopCollectQuestion',
  data () {
    return {
      loading: false,
      likeService: [],
      likeContent: [],
      likeServiceOther: ''
    }
  },
  methods: {
    showErroMsg (msg) {
      this.$toast({
        type: 'fail',
        duration: 1000,
        message: msg
      })
    },
    handleSubmit () {
      // 检查是否有未填项
      if (!this.likeService.length) {
        this.showErroMsg('请选择您喜欢的增值服务')
        return
      }
      console.log(this.likeService)
      if (this.likeService.indexOf('05') > -1 && !this.likeServiceOther) {
        this.showErroMsg('请告诉我们其他服务内容')
        return
      }
      if (!this.likeContent.length) {
        this.showErroMsg('请选择您喜欢的公众号内容')
        return
      }
      const params = {
        likeService: this.likeService.toString(),
        likeContent: this.likeContent.toString(),
        likeServiceOther: this.likeService.indexOf('05') > -1 ? this.likeServiceOther : ''
      }
      this.$toast.loading({
        message: '问卷提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi
        .workshopCollectTask4Submit(params)
        .then((response) => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            // 提交成功后跳转到活动主页面
            this.$router.back()
          } else {
            this.showErroMsg(response.data.resultMsg)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.questionbg {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/activity/workshop/mainbg.png");
  background-size: 100% 100%;
  background-repeat: repeat-y;
  .info-text {
    padding: 50px 128px 20px 128px;
    .info-img {
      width: 118px;
      height: 29px;
    }
  }
  .info-content {
    width: 80%;
    height: 450px;
    margin: 0 auto;
    border-radius: 10px;
    background-color: rgb(250, 250, 250);
  }
  .input-row {
    position: relative;
    height: 240px;
    .info-name {
      position: absolute;
      top: 15px;
    }
    .icon-user {
      position: absolute;
      left: 16px;
      right: 16px;
      .info-icon {
        width: 9px;
        height: 20px;
        background-color: rgb(227, 106, 91);
        border-radius: 50px;
        display: inline-block;
        margin-right: 8px;
      }
    }
  }
}
.van-checkbox-group {
  margin: 17px;
}
.van-field {
  position: absolute;
  top: 180px;
  width: 220px;
  height: 30px;
  background-color: rgb(250, 250, 250);
  border: 1px rgb(214, 210, 210) solid;
  margin: 0 17px;
}
.van-checkbox {
  padding: 0 10px 8px 0;
}
.submit-btn {
  margin: 20px 5px;
  text-align: center;
  .van-button {
    width: 343px;
    height: 50px;
    line-height: 50px;
    background: rgb(227, 106, 91);
    border: none;
    border-radius: 8px;
    .imgbtn {
      width: 43px;
      height: 19px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto auto;
    }
  }
}
</style>
